import { all, call, put, takeLatest } from 'redux-saga/effects';
import { request } from '../../common/util/RestClient';
import {
  fetchActivityTypes,
  fetchActivityTypesLookup,
  createActivityType,
  editActivityType,
  changeActivityTypeActiveStatus,
} from '../routines';
import envConfig from '../../config';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';

export async function filterActivityTypeByName({ displayName }) {
  let URL = `${envConfig.APIG_URL}core/activity-type`;

  if (displayName) {
    URL = `${URL}?displayName=${displayName}`;
  } else {
    throw new Error('No Value Entered!');
  }

  try {
    const response = await request(URL);
    return response;
  } catch (error) {
    return null;
  }
}

export function* fetchActivityTypesSaga() {
  try {
    const URL = `${envConfig.APIG_URL}core/activity-type`;
    const response = yield call(request, URL);
    yield put(fetchActivityTypes.success(response));
  } catch (error) {
    yield put(fetchActivityTypes.failure({ error }));
  } finally {
    yield put(fetchActivityTypes.fulfill());
  }
}
export function* fetchActivityTypesLookupSaga() {
  try {
    const URL = `${envConfig.APIG_URL}core/activity-type?format=object`;
    const response = yield call(request, URL);
    yield put(fetchActivityTypesLookup.success(response));
  } catch (error) {
    yield put(fetchActivityTypesLookup.failure({ error }));
  } finally {
    yield put(fetchActivityTypesLookup.fulfill());
  }
}

export function* createActivityTypeSaga({ payload }) {
  try {
    const URL = `${envConfig.APIG_URL}core/activity-type`;
    const config = { method: 'POST', payload };
    const response = yield call(request, URL, config);
    yield put(
      createActivityType.success({
        response,
        successMessage: SUCCESS_MESSAGES.ADD_ACTIVITY_TYPE,
      })
    );
    yield put(fetchActivityTypes.trigger());
    yield put(fetchActivityTypesLookup.trigger());
  } catch (error) {
    yield put(createActivityType.failure({ error }));
  } finally {
    yield put(createActivityType.fulfill());
  }
}

export function* changeActivityTypeActiveStatusSaga({ payload }) {
  const { displayName, iconName, description, isActive, activityTypeId } =
    payload;
  try {
    const body = {
      displayName,
      iconName,
      description,
      isActive,
    };
    const URL = `${envConfig.APIG_URL}core/activity-type/${activityTypeId}`;
    const config = { method: 'PATCH', payload: body };
    const response = yield call(request, URL, config);
    yield put(
      editActivityType.success({
        response,
        successMessage: SUCCESS_MESSAGES.EDIT_ACTIVITY_TYPE,
      })
    );

    yield put(fetchActivityTypes.trigger());
    yield put(fetchActivityTypesLookup.trigger());
  } catch (error) {
    yield put(editActivityType.failure({ error }));
  } finally {
    yield put(editActivityType.fulfill());
  }
}
export function* editActivityTypeSaga({ payload }) {
  const { activityTypeData, currentActivityType } = payload;
  try {
    const body = {
      ...activityTypeData,
      isActive: currentActivityType.isActive,
    };
    const URL = `${envConfig.APIG_URL}core/activity-type/${currentActivityType.activityTypeId}`;
    const config = { method: 'PATCH', payload: body };
    const response = yield call(request, URL, config);
    yield put(
      editActivityType.success({
        response,
        successMessage: SUCCESS_MESSAGES.EDIT_ACTIVITY_TYPE,
      })
    );

    yield put(fetchActivityTypes.trigger());
    yield put(fetchActivityTypesLookup.trigger());
  } catch (error) {
    yield put(editActivityType.failure({ error }));
  } finally {
    yield put(editActivityType.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchActivityTypes.TRIGGER, fetchActivityTypesSaga),
    takeLatest(fetchActivityTypesLookup.TRIGGER, fetchActivityTypesLookupSaga),
    takeLatest(createActivityType.TRIGGER, createActivityTypeSaga),
    takeLatest(editActivityType.TRIGGER, editActivityTypeSaga),
    takeLatest(
      changeActivityTypeActiveStatus.TRIGGER,
      changeActivityTypeActiveStatusSaga
    ),
  ]);
}
